import { z } from "zod";

import { RedirectDtoSchema } from "../../../dtos/redirects";

export const PutRedirectRequestBodySchema = RedirectDtoSchema;

export type PutRedirectRequestBodyType = z.infer<
  typeof PutRedirectRequestBodySchema
>;
